<template>
  <div>
    <!-- BEGIN breadcrumb -->
    <ol class="breadcrumb float-xl-end">
      <li class="breadcrumb-item"><a href="javascript:;">Reportes</a></li>
      <li class="breadcrumb-item"><a href="javascript:;">Bancos</a></li>
      <li class="breadcrumb-item active"><a href="javascript:;">NetPay</a></li>
    </ol>
    <!-- END breadcrumb -->
    <!-- BEGIN page-header -->
    <h1 class="page-header">NetPay<small>.</small></h1>
    <!-- <button class="btn" v-on:click="redirectTanques()">tanques</button> -->
    <!-- END page-header -->
    <!-- <a href="javascript:;" v-on:click="show('top-right', 'warn')" class="btn btn-sm btn-primary">Demo</a> -->

    <div class="row">
      <div class="col-md-8">
        <form @submit.prevent="search">
          <div class="form-group row">
            <div class="col-md-3">
              <label class="col-form-label">Fecha</label>
              <div class="input-group">
                <date-picker id="dateTimeInput" v-model="date" :config="options"></date-picker>
                <label for="dateTimeInput" class="input-group-text">
                  <i class="fa fa-calendar"></i>
                </label>
              </div>
            </div>

            <div class="col-md-3">
              <label class="col-form-label">Ciudad</label>
              <select class="form-select" @change="getEstaciones()" v-model="ciudadSelect"
                :disabled="deshabilitarCombos">
                <option v-for="ciudad in ciudades" :value="ciudad.Id" v-bind:key="ciudad.Id">
                  {{ ciudad.Nombre }}
                </option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="col-form-label">Estación</label>
              <select class="form-select" v-model="estacionSelect" :disabled="deshabilitarCombos">
                <option value="0">Seleccione</option>
                <option v-for="estacion in estaciones" :value="estacion.NoEstacion" v-bind:key="estacion.NoEstacion">
                  {{ estacion.Nombre }}
                </option>
              </select>
            </div>
            <div class="col-md-3" style="padding-top: 2.65em;">
              <button type="submit" class="btn btn-success me-1 mb-1 pull-right">{{ textoBotonBuscar }}</button>
            </div>
          </div>
        </form>
      </div>




    </div>


    <DxDataGrid id="gridContainer" :data-source="ReporteGetNet" key-expr="transaction_id" :show-borders="true"
      @exporting="onExporting" :show-column-lines="true" :show-row-lines="true" :row-alternation-enabled="true"
      :allow-column-resizing="true" :column-auto-width="true" :column-width="100" @row-prepared="onRowPrepared">

      <DxScrolling column-rendering-mode="virtual" />
      <DxPager :show-page-size-selector="true" :allowed-page-sizes="[10, 20, 50, 100]"
        :show-navigation-buttons="true" />
      <DxPaging :page-size="10" :page-index="1" />
      <DxFilterRow />
      <DxHeaderFilter :visible="showHeaderFilter" />
      <DxSearchPanel :visible="true" :width="240" placeholder="Search..." />

      <DxGroupPanel :visible="true" />
      <DxGrouping :auto-expand-all="true" />
      <DxExport :enabled="true" :allow-export-selected-data="false" />
      <DxSelection mode="false" />

      <DxColumn data-field="transaction_date" caption="Fecha" width="150" :customize-text="formatDateYYYYMMDD" />
      <DxColumn data-field="branch_name" caption="Estacion" width="250" />
      <DxColumn data-field="auth_amount" caption="Total" dataType="number" width="100">
        <DxFormat type="currency" :precision="2" />
      </DxColumn>
      <DxColumn data-field="card_type" caption="Tipo Tarjeta" width="100" />
      <DxColumn data-field="brand" caption="Marca" width="100" />
      <DxColumn data-field="span_route_num" caption="Tarjeta" width="150" />
      <DxColumn data-field="nomcontraparte" caption="Banco" width="150" />
      <DxColumn data-field="status" caption="Estatus" width="100" cell-template="estatusLabel" />
      <DxColumn data-field="response_msg" caption="Mensaje" width="250" />


      <template #estatusLabel="{ data }">
        <div>
          <i v-if="data.data.status == 'Aprobada'" class="fas fa-lg fa-fw me-10px fa-check iconColorCheck"
            :data-estatus="data"></i>
          <i v-if="data.data.status != 'Aprobada'" class="fas fa-lg fa-fw me-10px fa-times iconColor"
            :data-estatus="data"></i>
        </div>
      </template>

      <!-- <DxColumn data-field="email_client" caption="Cliente" width="250" /> -->
      <DxColumn data-field="external_reference" caption="Referencia" width="250" />


      <DxSummary>
        <DxGroupItem column="auth_amount" summary-type="sum" value-format="$#,##0.##" displayFormat='Total: {0}' />
      </DxSummary>
    </DxDataGrid>


    <!-- bottom left vue-notification -->
    <notifications group="top-right" position="top right" :speed="1000" />
  </div>
</template>

<script>

import axios from 'axios';
import moment from 'moment';
import {
  DxDataGrid, DxFormat,
  DxPaging, DxPager, DxScrolling, DxColumn, DxExport, DxSelection, DxGroupPanel, DxSummary, DxGroupItem, DxGrouping, DxHeaderFilter, DxFilterRow, DxSearchPanel,
} from 'devextreme-vue/data-grid';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
// Our demo infrastructure requires us to use 'file-saver-es'. We recommend that you use the official 'file-saver' package in your applications.
import { exportDataGrid } from 'devextreme/excel_exporter';
//import service from './data.js';

export default {
  beforeCreate() {
    // var userSetting = localStorage.getItem('userSettings');
    // if(userSetting != undefined){
    //   console.log(JSON.parse(userSetting));
    //   this.pageUserSettings = JSON.parse(userSetting);
    // }else{
    // 	this.$router.push('/login');
    // }
  },
  created() {
    // console.log('created');
  },
  beforeMount() {
    // console.log('beforeMount');
  },
  mounted() {
    //debugger; // eslint-disable-line no-debugger
    var userSetting = JSON.parse(localStorage.getItem('userSettings'));
    this.usuario = userSetting.Usuario;
    this.idUsuario = userSetting.NumeroEmpleado;
    this.nombreLogueado = userSetting.Nombre;
    this.usuarioEstacion = userSetting.Estacion;
    this.IdRol = userSetting.IdRol;
    this.getCiudades();
    this.ciudadSelect = userSetting.CiudadId;
    this.getEstaciones();
    this.estacionSelect = userSetting.Estacion;

    if (this.IdRol == 3 || this.IdRol == 7) {
      this.deshabilitarCombos = true;
    }
  },
  components: {
    DxDataGrid, DxFormat,
    DxPaging, DxPager, DxScrolling, DxColumn, DxExport, DxSelection, DxGroupPanel, DxGrouping, DxSummary, DxGroupItem,
    DxHeaderFilter, DxFilterRow, DxSearchPanel,
  },
  methods: {
    onRowPrepared(e) {
      if (e.rowType !== 'data') return;
      //const resp = (e.data.Estatus ?? false).toString().trim().toLowerCase();
      // Limpia cualquier color previo (por reciclaje de filas en virtual scroll)
      e.rowElement.querySelectorAll('td').forEach(td => {
        td.style.removeProperty('background-color');
      });

      if (!e.data.status) {
        e.rowElement.querySelectorAll('td').forEach(td => {
          // 'important' para ganar a alternation/hover/selection
          td.style.setProperty('background-color', '#ffe5e5', 'important'); // rojo claro
        });
      } else if (e.data.status) {
        // opcional: pinta en verde
        // e.rowElement.querySelectorAll('td').forEach(td => td.style.setProperty('background-color', '#e9fbe9', 'important'));
      }
    },
    formatDateYYYYMMDD(e) {
      if (!e.value) return "";

      let parsed = null;
      if (e.value instanceof Date) {
        if (!isNaN(e.value.getTime())) {
          parsed = moment(e.value);
        }
      } else if (typeof e.value === "number") {
        parsed = moment(e.value);
      } else if (typeof e.value === "string") {
        parsed = moment(
          e.value,
          [
            "YYYY-MM-DD HH:mm:ss",
            "YYYY-MM-DD HH:mm:ss.SSS",
            "YYYY-MM-DDTHH:mm:ss",
            "YYYY-MM-DDTHH:mm:ss.SSS",
            "YYYY-MM-DDTHH:mm:ssZ",
            "YYYY-MM-DDTHH:mm:ss.SSSZ",
            "YYYY-MM-DD",
            "DD/MM/YYYY HH:mm:ss",
            "DD/MM/YYYY HH:mm",
            "DD/MM/YYYY"
          ],
          true
        );

        if (!parsed.isValid()) {
          parsed = moment(e.value, moment.ISO_8601, true);
        }

        if (!parsed.isValid()) {
          parsed = moment(e.value);
        }
      }

      if (!parsed || !parsed.isValid()) return "";

      return parsed.format("DD/MM/YYYY HH:mm");
    },
    async getCiudades() {
      try {
        const response = await axios.get('Catalogos/GetCiudades');
        //debugger; // eslint-disable-line no-debugger
        if (response.data.Success) {
          if (response.data.response.length == 0) {
            this.alertMessage = "No se encontró información.";
            this.alertTitle = "Error";
            this.show('top-right', 'error');
          }
        } else {
          console.log("error")
          this.alertMessage = response.data.Error;
          this.alertTitle = "Error";
          this.show('top-right', 'error');
        }
        this.ciudades = response.data.response;
      } catch (e) {
        //this.alert = true;
        //this.error = 'Invalid email/password';
      }
    },
    async getEstaciones() {
      try {
        //debugger; // eslint-disable-line no-debugger
        const response = await axios.post('Estacion/GetEstaciones?ciudad=' + this.ciudadSelect);
        if (response.data.Success) {
          if (response.data.response.length == 0) {
            this.alertMessage = "No se encontró información.";
            this.alertTitle = "Error";
            this.show('top-right', 'error');
          }
        } else {
          console.log("error")
          this.alertMessage = response.data.Error;
          this.alertTitle = "Error";
          this.show('top-right', 'error');
        }
        this.estaciones = response.data.response;
        this.productos = [];
        this.getProductos();
      } catch (e) {
        //this.alert = true;
        //this.error = 'Invalid email/password';
      }
    },
    show(group, type = '') {
      const text = this.alertMessage;
      this.$notify({
        group,
        title: this.alertTitle,
        text,
        type,
        data: {
          randomNumber: Math.random()
        }
      })
    },
    clean(group) {
      this.$notify({ group, clean: true })
    },
    swalNotification(swalType) {
      var btnClass = (swalType == 'error') ? 'danger' : swalType;
      btnClass = (swalType == 'question') ? 'primary' : btnClass;
      this.$swal({
        title: 'Are you sure?',
        text: 'You will not be able to recover this imaginary file!',
        type: swalType,
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: swalType.charAt(0).toUpperCase() + swalType.substr(1).toLowerCase(),
        cancelButtonText: 'Cancel',
        confirmButtonClass: 'btn me-5px btn-' + btnClass + '',
        cancelButtonClass: 'btn btn-default',
      })
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('ReporteGetNet');

      exportDataGrid({
        component: e.component,
        worksheet: worksheet,
        autoFilterEnabled: true
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Centro de pagos.xlsx');
        });
      });
      e.cancel = true;
    },
    formatearFecha(fecha) {
      const [dia, mes, anio] = fecha.split("/");
      return `${anio}-${mes}-${dia}`;
    },
    async search(e) {
      //debugger; // eslint-disable-line no-debugger
      e.preventDefault();
      var self = this;
      self.textoBotonBuscar = "Buscando...";
      try {
        // this.intDate = this.date.replace('/', '');
        // this.intDate = this.intDate.replace('/', '');
        var sendDate = self.formatearFecha(self.date);
        var estacion = self.estacionSelect;
        if (estacion == "0") {
          this.alertMessage = "Seleccione estación";
          this.alertTitle = "Error";
          this.show('top-right', 'error');
          return;
        }
        const response = await axios.post('Netpay/GetTransactiones', {
          "Data": {
            "Estacion": estacion,
            "Fecha": sendDate,//   D/M/Y
            //"Banco": 2
          }
        }
        );

        //debugger; // eslint-disable-line no-debugger
        if (response.data.Success) {

          if (response.data.response.length == 0) {
            this.alertMessage = "No se erncontro información del día especificado.";
            this.alertTitle = "Error";
            this.show('top-right', 'error');
            this.ReporteGetNet = [];
          } else {
            self.ReporteGetNet = response.data.response;

            for (var r = 0; r < self.ReporteGetNet.length; r++) {
              if (self.ReporteGetNet[r].nb_resp == 'Aprobado') {
                self.ReporteGetNet[r].importeReal = self.ReporteGetNet[r].nu_importe;
              } else {
                self.ReporteGetNet[r].importeReal = "0.00";
              }

            }
          }
        } else {
          this.ReporteGetNet = [];
          console.log("error")
          this.alertMessage = response.data.Message;
          this.alertTitle = "Error";
          this.show('top-right', 'error');
        }

        this.textoBotonBuscar = "Buscar";
      } catch (e) {
        this.ReporteGetNet = [];
        this.alertMessage = "Ocurrió un error";
        this.alertTitle = "Error";
        this.show('top-right', 'error');
        //this.alert = true;
        //this.error = 'Invalid email/password';
      }
    },
  },
  data() {
    return {
      showHeaderFilter: true,
      loading: false,
      nombreLogueado: "",
      idUsuario: undefined,
      reportefajillas: [],
      deshabilitarCombos: false,
      ciudades: [],
      estaciones: [],
      ciudadSelect: 1,
      estacionSelect: 0,
      pageUserSettings: {},
      alertMessage: "",
      alertTitle: "",
      ReporteGetNet: [],
      textoBotonBuscar: "Buscar",
      date: moment().format("DD/MM/YYYY"),
      intDate: "",
      options: {
        format: 'DD/MM/YYYY',
        useCurrent: false,
      }
    };
  }
}
</script>
<style scoped>
.dx-datagrid-header-panel {
  display: none !important;
}

.iconColor {
  color: #f70909;
  font-size: 20px;
}

.iconColorCheck {
  color: #28a70e;
  font-size: 20px;
}

.dx-datagrid-rowsview .dx-row .dx-datagrid-content .respuesta-rejected {
  background-color: #ffe5e5 !important;
  /* rojo claro */
}

.dx-datagrid-rowsview .dx-row .dx-datagrid-content .respuesta-approved {
  background-color: #e9fbe9 !important;
  /* verde claro */
}


/* #gridContainer {
  height: 440px;
} */
</style>
